import React from 'react';
import { Global } from '@emotion/react';

const skeletonWidthArr = ['30%', '25%', '60%', '50%', '30%', '60%', '60%', '50%'];

export const FilterSkeleton = () => (
  <>
    <Global
      styles={{
        '.skeleton-container': {
          padding: '2.672rem 2.672rem 0 2.672rem',
          position: 'absolute',
          top: '0',
          zIndex: '0',
          width: '100%',
        },
        '.stack': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '1.336rem',
        },
        '.skeleton': {
          height: '20px',
          '--skeleton-start-color': '#f7fafc',
          '--skeleton-end-color': '#a0aec0',
          opacity: 0.7,
          boxShadow: 'none',
          backgroundClip: 'padding-box',
          cursor: 'default',
          color: 'transparent',
          pointerEvents: 'none',
          userSelect: 'none',
          borderColor: '#a0aec0',
          borderRadius: '0.125rem',
          animation: '0.8s linear 0s infinite alternate none running animation-14pkoxc',
          marginBottom: '2.04rem',
        },
      }}
    />
    <div className="skeleton-container" data-testid="skeleton-container">
      <div className="stack">
        {skeletonWidthArr.map((width, i) => (
          <div className="skeleton" key={`skeleton-${i}`} style={{ width }} />
        ))}
      </div>
    </div>
  </>
);
